import { render, staticRenderFns } from "./editDrawer.vue?vue&type=template&id=b9c8b994&scoped=true"
import script from "./editDrawer.vue?vue&type=script&lang=js"
export * from "./editDrawer.vue?vue&type=script&lang=js"
import style0 from "./editDrawer.vue?vue&type=style&index=0&id=b9c8b994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8b994",
  null
  
)

export default component.exports